import { ConfiguratorRenewalAction } from '@models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, featureKey } from './reducer';

export const selectGetRenewalActionsState = createFeatureSelector<State>(featureKey);

export const getRenewalActionsGetData = createSelector(selectGetRenewalActionsState, (state: State) => state.data);

export const getRenewalActionsGetError = createSelector(selectGetRenewalActionsState, (state: State) => state.error);

export const getRenewalActionsGetLoading = createSelector(
  selectGetRenewalActionsState,
  (state: State) => state.loading
);

export const getRenewalActionsMapData = <T>(fn: (data: ConfiguratorRenewalAction[]) => T) =>
  createSelector(selectGetRenewalActionsState, (state: State) => fn(state.data));
